import * as React from "react"
import { useGridApiContext } from "@mui/x-data-grid"
import { DatePicker } from "@mui/x-date-pickers"
import { TextField } from "@mui/material"
import { CommonConstant } from "shared/constants/common-constant"

const DateTimeEditInputCell = ({ id, value, field }) => {
  const apiRef = useGridApiContext()

  const handleChange = newVal => {
    apiRef.current.setEditCellValue({ id, field, value: newVal })
    apiRef.current.stopCellEditMode({ id, field })
  }

  return <DatePicker format={CommonConstant.DATE_FORMAT} value={value} onChange={handleChange} renderInput={props => <TextField fullWidth {...props} />} />
}

export default DateTimeEditInputCell
